import React from "react";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { InputAdornment } from "@mui/material";
import { pickersLayoutClasses } from "@mui/x-date-pickers/PickersLayout";
import { VIEW_HEIGHT } from "@mui/x-date-pickers/internals/constants/dimensions";
import BDateTimePickerToolbar from "./BDateTimePickerToolbar";

/**
 * Mobile `PickersLayout` stacks `DateTimePickerTabs` then the view inside `contentWrapper`.
 * `minHeight` must cover tabs + calendar (`VIEW_HEIGHT`) so switching to the shorter time clock
 * does not shrink the dialog (MUI `Tab` icon-only row uses minHeight 48).
 */
const DATETIME_TABS_ROW_MIN_HEIGHT_PX = 48;
const LAYOUT_CONTENT_MIN_HEIGHT_PX =
  DATETIME_TABS_ROW_MIN_HEIGHT_PX + VIEW_HEIGHT;

export default function BDateTimePicker(props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MobileDateTimePicker
        {...props}
        slots={{
          ...props.slots,
          toolbar: props.slots?.toolbar ?? BDateTimePickerToolbar,
        }}
        slotProps={{
          ...props.slotProps,
          actionBar: {
            ...props.slotProps?.actionBar,
            actions: props.slotProps?.actionBar?.actions ?? ["clear", "accept"],
            sx: {
              marginTop: 0,
              width: "100%",
              boxSizing: "border-box",
              justifyContent: "flex-start",
              gap: 1,
              "& > .MuiButton-root": {
                flex: "1 1 0",
                minWidth: 0,
              },
            },
          },
          toolbar: {
            ...props.slotProps?.toolbar,
            hidden: props.slotProps?.toolbar?.hidden ?? false,
          },
          layout: {
            ...props.slotProps?.layout,
            sx: {
              [`& .${pickersLayoutClasses.contentWrapper}`]: {
                minHeight: LAYOUT_CONTENT_MIN_HEIGHT_PX,
                // Center the time clock vertically when it is shorter than the calendar slot.
                "& > *:last-child": {
                  marginTop: "auto",
                  marginBottom: "auto",
                },
              },
              ...(typeof props.slotProps?.layout?.sx === "object" &&
              props.slotProps?.layout?.sx != null &&
              !Array.isArray(props.slotProps.layout.sx)
                ? props.slotProps.layout.sx
                : {}),
            },
          },
          textField: {
            required: props.required,
            fullWidth: props.fullWidth,
            variant: props.variant || "outlined",
            ...props.slotProps?.textField,
            InputProps: {
              ...props.slotProps?.textField?.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  {!props.hideIcon && <CalendarMonthOutlinedIcon />}
                </InputAdornment>
              ),
            },
          },
        }}
        views={["day", "hours", "minutes"]}
        format="MMM d, y h:m a"
        ampmInClock={true}
        value={props.value ? new Date(props.value) : null}
        onChange={(value) => props.onChange(value)}
      />
    </LocalizationProvider>
  );
}
